'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import { APP_RATINGS, CLEARTRIP_APP_LINKS, FLYIN_APP_LINKS } from '@/src/constants/appDownloadLinks'
import { getBrandName } from '@/src/utils/buildUtils'
import { isFlyin } from '@/src/utils/generalUtils/isFlyin'

import { AppDownload } from './appDownload'

import appStoreBadge from '@/src/assets/png/app-store.png'
import cleartripDesktopBg from '@/src/assets/png/ct-app-download.png'
import cleartripQr from '@/src/assets/png/CT-QR.png'
import flyinDesktopBg from '@/src/assets/png/flyin-app-download.png'
import flyinQr from '@/src/assets/png/Flyin-QR.png'
import playStoreBadge from '@/src/assets/png/play-store.png'

interface AppDownloadWrapperProps {
    // Optional override; the ratings row otherwise shows for Flyin only.
    showStats?: boolean
}

const AppDownloadWrapper: React.FC<AppDownloadWrapperProps> = ({ showStats }) => {
    const t = useTranslations('appDownload')
    const tVariants = useTranslations('variants')

    const flyin = isFlyin()
    const brandName = tVariants(getBrandName())
    const links = flyin ? FLYIN_APP_LINKS : CLEARTRIP_APP_LINKS

    const stats = [
        { value: APP_RATINGS.GOOGLE_PLAY, label: t('googlePlay'), showStar: true },
        { value: APP_RATINGS.APP_STORE, label: t('appStore'), showStar: true },
        { value: APP_RATINGS.DOWNLOADS, label: t('downloads'), showStar: false }
    ]

    return (
        <AppDownload
            title={t('title', { brandName })}
            subtitle={t('subtitle')}
            qrAlt={t('qrAlt')}
            showStats={showStats ?? flyin}
            stats={stats}
            desktopBgSrc={(flyin ? flyinDesktopBg : cleartripDesktopBg).src}
            qrSrc={flyin ? flyinQr : cleartripQr}
            playStoreBadge={playStoreBadge}
            appStoreBadge={appStoreBadge}
            androidUrl={links.android}
            iosUrl={links.ios}
        />
    )
}

export { AppDownloadWrapper }
export default AppDownloadWrapper
